/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { useHistory } from 'react-router';
import { EnsureAuthWrapper } from '../../common/EnsureAuthWrapper/EnsureAuthWrapper';
import { useRoom } from '../../../hooks/useRoom';
import { participantAPI } from '../../../api/participant';
import { AccessRoomError } from '@shared/constants/room';
import { get } from '@utils/lodash';

export interface ParticipantRoomWrapperProps {
  children?: React.ReactNode;
}

export const SessionWrapper: React.SFC<ParticipantRoomWrapperProps> = ({ children }) => {
  const { roomId } = useRoom();
  const history = useHistory();
  const ensureAuthenticated = async () => {
    try {
      await participantAPI.rooms.ensureSession(roomId);
    } catch (e) {
      const status = get(e, 'response.status');
      const msg = get(e, 'response.data.message');

      const isParticipantEarly = status === 400 && msg === AccessRoomError.PARTICIPANT_JOINING_BEFORE_SCHEDULED_START;
      const isCallNotAssignedOrScheduled =
        (status === 400 && msg === AccessRoomError.PARTICIPANT_JOINING_BEFORE_ROOM_SCHEDULED) ||
        (status === 404 && roomId);
      const isCallFinished = status === 400 && msg === AccessRoomError.PARTICIPANT_JOINING_AFTER_SCHEDULED_END;

      if (isParticipantEarly) {
        history.push(`/rooms/${roomId}/early`);
      } else if (isCallNotAssignedOrScheduled) {
        history.push(`/rooms/${roomId}/not-scheduled`);
      } else if (isCallFinished) {
        history.push(`/rooms/${roomId}/finish`);
      } else {
        throw e;
      }
    }
  };

  return <EnsureAuthWrapper ensureAuthenticated={ensureAuthenticated}>{children}</EnsureAuthWrapper>;
};
